(function () {
    function rewardsConfigObject() {
        return window.renogyConfig || {};
    }

    function rewardsTokenKey(kind) {
        return 'renogy_account_' + kind + '_token_key_' + (rewardsConfigObject().mode || '') + '_1.0';
    }

    function rewardsCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length < 2) return '';
        var raw = parts.pop().split(';').shift() || '';
        try {
            return decodeURIComponent(raw);
        } catch (error) {
            return raw;
        }
    }

    function rewardsJwtPayload(token) {
        var parts = String(token || '').split('.');
        if (parts.length < 2) return null;
        try {
            var base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            while (base64.length % 4) base64 += '=';
            return JSON.parse(atob(base64));
        } catch (error) {
            return null;
        }
    }

    function rewardsAccessTokenLive() {
        var payload = rewardsJwtPayload(rewardsCookie(rewardsTokenKey('access')));
        if (!payload || payload.exp == null || payload.exp === '') return false;
        return Number(payload.exp) * 1000 > Date.now();
    }

    // Refresh cookies in this account service often have iat/jti and no exp.
    // A missing exp stays usable. A present exp in the past does not.
    function rewardsRefreshTokenUsable() {
        var token = rewardsCookie(rewardsTokenKey('refresh'));
        if (!token) return false;
        var payload = rewardsJwtPayload(token);
        if (!payload || payload.exp == null || payload.exp === '') return true;
        return Number(payload.exp) * 1000 > Date.now();
    }

    function rewardsHasIdentity(shopifyCustomer) {
        if (shopifyCustomer) return true;
        return String(rewardsConfigObject().user_email || '').trim() !== '';
    }

    function rewardsWhenAuthReady() {
        if (window.RenogyAuth && (typeof window.RenogyAuth.refreshToken === 'function' || typeof window.RenogyAuth.request === 'function')) {
            return Promise.resolve();
        }
        // Later defer scripts, including renogy-auth.js, still run before DOMContentLoaded.
        if (document.readyState === 'complete') return Promise.resolve();
        return new Promise(function (resolve) {
            document.addEventListener('DOMContentLoaded', resolve, { once: true });
        });
    }

    // No identity, or a missing or expired refresh token, is logged out immediately.
    // An expired access token is refreshed once only when both the identity and the refresh token are still usable.
    function rewardsEnsureLogin(shopifyCustomer) {
        if (!rewardsHasIdentity(shopifyCustomer) || !rewardsRefreshTokenUsable()) {
            return Promise.resolve(false);
        }
        if (rewardsAccessTokenLive()) return Promise.resolve(true);

        return rewardsWhenAuthReady().then(function () {
            if (!window.RenogyAuth || typeof window.RenogyAuth.refreshToken !== 'function') {
                return false;
            }
            return window.RenogyAuth.refreshToken().then(function () {
                return rewardsHasIdentity(shopifyCustomer) && rewardsRefreshTokenUsable() && rewardsAccessTokenLive();
            }).catch(function () {
                return false;
            });
        });
    }

    function initRgRewards(boot) {
        if (!boot || !boot.sectionId) return;
        var root = document.getElementById('shopify-section-' + boot.sectionId);
        if (!root || root.getAttribute('data-rg-rewards-ready') === '1') return;

        var stateEl = root.querySelector('[data-rg-rewards]');
        if (!stateEl) return;
        root.setAttribute('data-rg-rewards-ready', '1');

        var rewardsConfig = boot.config || {};
        var rewardsUi = boot.ui || {};

        function rewardsPlainText(value) {
            return String(value == null ? '' : value)
                .replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'");
        }

        function rewardsPlainFields(bag) {
            if (!bag) return;
            Object.keys(bag).forEach(function (key) {
                if (typeof bag[key] === 'string') bag[key] = rewardsPlainText(bag[key]);
            });
        }

        // The json filter writes "&" as "&amp;" inside a script tag, which leaves the entity visible.
        rewardsPlainFields(rewardsUi);
        rewardsPlainFields(boot.titles);
        rewardsPlainFields(boot.highlights);
        rewardsPlainFields(boot.descriptions);
        if (typeof boot.subscribeError === 'string') boot.subscribeError = rewardsPlainText(boot.subscribeError);
        if (typeof rewardsConfig.couponsPendingText === 'string') {
            rewardsConfig.couponsPendingText = rewardsPlainText(rewardsConfig.couponsPendingText);
        }
        if (typeof rewardsConfig.depositPrice === 'string') {
            rewardsConfig.depositPrice = rewardsPlainText(rewardsConfig.depositPrice);
        }
        var rewardsCouponTotalReady = !!rewardsConfig.couponsTotalCustom;
        var rewardsCountSources = {};
        var shopifyLoggedIn = boot.shopifyCustomer === true
            || String((window.renogyConfig && window.renogyConfig.user_email) || '').trim() !== '';
        var loggedIn = false;
        var ordered = stateEl.getAttribute('data-ordered') === 'true';
        var startRaw = String(rewardsConfig.start || '').trim();
        var endRaw = String(rewardsConfig.end || '').trim();
        var start = Date.parse(startRaw);
        var end = Date.parse(endRaw);
        var now = Date.now();
        var stage = 'live';

        if (!isNaN(start) && now < start) {
            stage = 'upcoming';
        } else if (!isNaN(end) && now > end) {
            stage = 'ended';
        }

        stateEl.setAttribute('data-stage', stage);
        if (!shopifyLoggedIn) stateEl.setAttribute('data-logged-in', 'false');
        stateEl.setAttribute('data-ordered', ordered ? 'true' : 'false');
        var productsEl = root.querySelector('[data-rg-rewards-products]');
        if (productsEl) productsEl.setAttribute('data-ordered', ordered ? 'true' : 'false');
        stateEl.rgRewardsState = {
            stage: stage,
            loggedIn: loggedIn,
            ordered: ordered
        };

        function escapePackHtml(value) {
            return String(value == null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        function getRewardsCurrencySymbol() {
            try {
                var shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
                var shopLocale = ((window.Shopify && window.Shopify.locale) || 'en') + '-' + ((window.Shopify && window.Shopify.country) || 'US');
                var formatter = new Intl.NumberFormat(shopLocale, { style: 'currency', currency: shopCurrency });
                var part = formatter.formatToParts(0).find(function (entry) { return entry.type === 'currency'; });
                return part ? part.value : '$';
            } catch (error) {
                return '$';
            }
        }

        function rewardsFill(template, vars) {
            return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
                return vars[key] != null ? String(vars[key]) : match;
            });
        }

        function formatRewardsBalance(amount) {
            var value = Math.max(0, Number(amount) || 0);
            var fixed = value.toFixed(2);
            var whole = fixed.split('.')[0];
            var cents = fixed.split('.')[1];
            function group(intPart, separator) {
                return String(intPart).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
            }
            var format = String(rewardsConfig.moneyFormat || '{{amount}}');
            var withDecimals = {
                amount_no_decimals_with_comma_separator: group(whole, '.') + ',' + cents,
                amount_with_comma_separator: group(whole, '.') + ',' + cents,
                amount_no_decimals_with_space_separator: group(whole, ' ') + ',' + cents,
                amount_with_space_separator: group(whole, ' ') + ',' + cents,
                amount_with_period_and_space_separator: group(whole, ' ') + '.' + cents,
                amount_with_apostrophe_separator: group(whole, "'") + '.' + cents,
                amount_no_decimals: group(whole, ',') + '.' + cents,
                amount: group(whole, ',') + '.' + cents
            };
            return format.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (match, key) {
                return withDecimals[key] != null ? withDecimals[key] : match;
            });
        }

        function formatRewardsMoney(amount) {
            var format = rewardsConfig.moneyFormat || '{{amount}}';
            var value = Math.max(0, Number(amount) || 0);
            var rounded = Math.round(value);
            var fixed = value.toFixed(2);
            var whole = fixed.split('.')[0];
            var cents = fixed.split('.')[1];
            function group(intPart, separator) {
                return String(intPart).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
            }
            var tokens = {
                amount_no_decimals_with_comma_separator: group(rounded, '.'),
                amount_no_decimals_with_space_separator: group(rounded, ' '),
                amount_with_comma_separator: group(whole, '.') + ',' + cents,
                amount_with_space_separator: group(whole, ' ') + ',' + cents,
                amount_with_period_and_space_separator: group(whole, ' ') + '.' + cents,
                amount_with_apostrophe_separator: group(whole, "'") + '.' + cents,
                amount_no_decimals: group(rounded, ','),
                amount: group(whole, ',') + '.' + cents
            };
            return String(format).replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (match, key) {
                return tokens[key] != null ? tokens[key] : match;
            });
        }

        function rewardsExpiryStamp(value) {
            var raw = String(value || '').trim();
            if (!raw) return '';
            var hasUtc = /z$/i.test(raw) || /\(utc\)/i.test(raw);
            var cleaned = raw.replace(/\(utc\)/ig, '').replace(/z$/i, '').trim();
            var match = cleaned.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}(?::\d{2})?)/);
            if (match) {
                var time = match[2].length === 5 ? match[2] + ':00' : match[2];
                return match[1] + ' ' + time + (hasUtc ? ' (UTC)' : '');
            }
            var dateOnly = cleaned.match(/^(\d{4}-\d{2}-\d{2})/);
            return dateOnly ? dateOnly[1] : cleaned;
        }

        function formatRewardsCouponExpiry(item) {
            var cutoffType = Number(item.cutoffType);
            if (cutoffType === 2) return rewardsUi.noExpiration;
            if ((cutoffType === 0 || (isNaN(cutoffType) && item.couponExpires && isNaN(Number(item.couponExpires)))) && item.couponExpires) {
                return rewardsFill(rewardsUi.validUntilLine, {
                    prefix: rewardsUi.validUntil,
                    date: rewardsExpiryStamp(item.couponExpires)
                });
            }
            if (cutoffType === 1 && item.createDate != null && item.couponExpires != null) {
                var startDate = new Date(item.createDate);
                var days = Number(item.couponExpires);
                if (!isNaN(startDate.getTime()) && !isNaN(days)) {
                    var resultDate = new Date(startDate.getTime() + days * 24 * 60 * 60 * 1000);
                    var y = resultDate.getFullYear();
                    var m = String(resultDate.getMonth() + 1).padStart(2, '0');
                    var d = String(resultDate.getDate()).padStart(2, '0');
                    return rewardsFill(rewardsUi.validUntilLine, {
                        prefix: rewardsUi.validUntil,
                        date: y + '-' + m + '-' + d
                    });
                }
            }
            return '';
        }

        function buildPackTicketTerms(item, product, currency) {
            var rules = Array.isArray(item.couponRuleList) ? item.couponRuleList.filter(Boolean) : [];
            if (rules.length) {
                return rules.map(function (rule, index) {
                    return '<li><span>' + (index + 1) + '.</span><span>' + escapePackHtml(rule) + '</span></li>';
                }).join('');
            }
            var amountLabel = item.couponTypeName === 'percentage_discount'
                ? rewardsFill(rewardsUi.percentOff, { amount: Number(item.couponAmount) })
                : rewardsFill(rewardsUi.amountOff, { amount: currency + Number(item.couponAmount || 0).toFixed(0) });
            var minLabel = currency + (item.minPurchase != null ? item.minPurchase : '');
            var productLabel = product.productName || rewardsUi.thisProduct;
            if (product.sku) productLabel += ' (' + product.sku + ')';
            return [
                '<li><span>1.</span><span>' + escapePackHtml(rewardsFill(rewardsUi.termEligibility, { product: productLabel })) + '</span></li>',
                '<li><span>2.</span><span>' + escapePackHtml(rewardsFill(rewardsUi.termDiscount, { amount: amountLabel, min: minLabel })) + '</span></li>',
                '<li><span>3.</span><span>' + escapePackHtml(rewardsFill(rewardsUi.termMinSpend, { min: minLabel })) + '</span></li>',
                '<li><span>4.</span><span>' + escapePackHtml(rewardsUi.termUsage) + '</span></li>'
            ].join('');
        }

        function findProductCardBySku(sku) {
            var normalized = String(sku || '').trim();
            if (!normalized) return null;
            var cards = root.querySelectorAll('.rg-rewards__product[data-sku]');
            var target = null;
            cards.forEach(function (card) {
                if ((card.getAttribute('data-sku') || '').trim() === normalized) target = card;
            });
            return target;
        }

        function renderPackTickets(list) {
            var mount = stateEl.querySelector('[data-rg-rewards-pack-tickets]');
            if (!mount) return;
            var currency = getRewardsCurrencySymbol();
            var html = (list || []).map(function (item) {
                var products = item.couponTemplateProductDetailContentList || [];
                if (!products.length) return '';
                var product = products[0] || {};
                var minText = rewardsFill(rewardsUi.minSpendLine, {
                    prefix: rewardsUi.minSpend,
                    amount: currency + (item.minPurchase != null ? item.minPurchase : '')
                });
                var untilText = formatRewardsCouponExpiry(item);
                var photo = product.productImageUrl || '';
                var productName = product.productName || '';
                var code = item.couponCode || '';
                var sku = product.sku || '';
                var skuInRail = !!(sku && findProductCardBySku(sku));
                var skuControl = skuInRail
                    ? '<button type="button" class="rg-rewards__pack-sku rg-rewards__when-guest" data-rg-rewards-sku-focus="' + escapePackHtml(sku) + '">' + escapePackHtml(rewardsUi.skuExclusive) + '</button>'
                    : '<span class="rg-rewards__pack-sku rg-rewards__when-guest is-disabled" aria-disabled="true">' + escapePackHtml(rewardsUi.skuExclusive) + '</span>';
                var status = rewardsMiniStatus(item);
                var lockLabel = status.state === 'inactive' ? rewardsUi.availableLaunch : rewardsUi.unavailable;
                var lockButton = status.state === 'usable' ? '' : [
                    '<button class="rg-rewards__pack-lock rg-rewards__when-ordered" type="button" data-rg-rewards-inactive="' + escapePackHtml(status.state) + '">',
                    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>',
                    escapePackHtml(lockLabel),
                    '</button>'
                ].join('');
                return [
                    '<article class="rg-rewards__pack-ticket' + (status.dimmed ? ' is-dimmed' : '') + '" data-coupon-template-id="' + escapePackHtml(item.couponTemplateId || '') + '" data-sku="' + escapePackHtml(sku) + '">',
                    '<div class="rg-rewards__pack-ticket-head">',
                    '<div>',
                    '<p class="rg-rewards__pack-off">' + escapePackHtml(rewardsPackOffAmount(item)) + '<span>' + escapePackHtml(rewardsUi.off) + '</span></p>',
                    '<p class="rg-rewards__pack-min">' + escapePackHtml(minText) + '</p>',
                    '</div>',
                    skuControl,
                    '<button class="rg-rewards__pack-copy rg-rewards__when-ordered" type="button" data-rg-rewards-copy="' + escapePackHtml(code) + '">' + escapePackHtml(rewardsUi.copyCoupon) + '</button>',
                    '</div>',
                    '<div class="rg-rewards__pack-tear"></div>',
                    '<div class="rg-rewards__pack-ticket-body">',
                    '<div class="rg-rewards__pack-product">',
                    photo
                        ? '<img class="rg-rewards__pack-photo" src="' + escapePackHtml(photo) + '" alt="" width="40" height="40">'
                        : '<span class="rg-rewards__pack-photo" aria-hidden="true"></span>',
                    '<div>',
                    '<p class="rg-rewards__pack-valid">' + escapePackHtml(rewardsUi.validFor) + '</p>',
                    '<p class="rg-rewards__pack-product-name">' + escapePackHtml(productName) + '</p>',
                    '</div>',
                    '</div>',
                    '<ol class="rg-rewards__pack-terms">' + buildPackTicketTerms(item, product, currency) + '</ol>',
                    '<div class="rg-rewards__pack-owned rg-rewards__when-ordered">',
                    '<span class="rg-rewards__pack-status ' + status.tone + '">' + escapePackHtml(status.label) + '</span>',
                    untilText ? '<p class="rg-rewards__pack-until">' + escapePackHtml(untilText) + '</p>' : '',
                    '</div>',
                    '<div class="rg-rewards__pack-foot">',
                    untilText ? '<p class="rg-rewards__pack-until rg-rewards__when-guest">' + escapePackHtml(untilText) + '</p>' : '',
                    lockButton,
                    '</div>',
                    '</div>',
                    '</article>'
                ].join('');
            }).join('');
            mount.innerHTML = html;
        }

        function rewardsMiniStatus(item) {
            var state = rewardsCouponCardState(item);
            var missingStatus = !item || item.couponStatus == null || item.couponStatus === '';
            if (!ordered && missingStatus) state = 'inactive';
            var labels = {
                inactive: rewardsUi.notActive,
                usable: rewardsUi.available,
                used: rewardsUi.couponUsed,
                expired: rewardsUi.couponExpired,
                abolished: rewardsUi.unavailable
            };
            var dimmed = state === 'used' || state === 'expired' || state === 'abolished';
            var tone = state === 'usable' ? 'is-usable' : (dimmed ? 'is-muted' : 'is-inactive');
            return {
                state: state,
                label: labels[state] || rewardsUi.notActive,
                dimmed: dimmed,
                tone: tone
            };
        }

        function renderBundleCards(list) {
            var mount = stateEl.querySelector('[data-rg-rewards-bundle-cards]');
            if (!mount) return;
            var currency = getRewardsCurrencySymbol();
            mount.innerHTML = (list || []).map(function (item) {
                var products = item.couponTemplateProductDetailContentList || [];
                if (!products.length) return '';
                var product = products[0] || {};
                var isPercent = item.couponTypeName === 'percentage_discount';
                var amountText = isPercent
                    ? (Number(item.couponAmount || 0) + '% ' + rewardsUi.off)
                    : (currency + Number(item.couponAmount || 0).toFixed(0) + ' ' + rewardsUi.off);
                var minText = (rewardsUi.minSpendMini || 'Min. spend') + ' ' + currency + (item.minPurchase != null ? item.minPurchase : '');
                var photo = product.productImageUrl || '';
                var productName = product.productName || '';
                var sku = product.sku || '';
                var skuInRail = !!(sku && findProductCardBySku(sku));
                var skuDesktop = skuInRail
                    ? '<button class="rg-rewards__bundle-sku rg-rewards__mini-sku-desktop" type="button" data-rg-rewards-sku-focus="' + escapePackHtml(sku) + '">' + escapePackHtml(rewardsUi.skuExclusive) + '</button>'
                    : '<span class="rg-rewards__bundle-sku rg-rewards__mini-sku-desktop" aria-disabled="true">' + escapePackHtml(rewardsUi.skuExclusive) + '</span>';
                var skuMobile = skuInRail
                    ? '<button class="rg-rewards__bundle-sku" type="button" data-rg-rewards-sku-focus="' + escapePackHtml(sku) + '">' + escapePackHtml(rewardsUi.skuExclusive) + '</button>'
                    : '<span class="rg-rewards__bundle-sku" aria-disabled="true">' + escapePackHtml(rewardsUi.skuExclusive) + '</span>';
                var status = rewardsMiniStatus(item);
                var statusHtml = '<span class="rg-rewards__bundle-pill ' + status.tone + '">' + escapePackHtml(status.label) + '</span>';
                return [
                    '<article class="rg-rewards__mini' + (status.dimmed ? ' is-dimmed' : '') + '" data-sku="' + escapePackHtml(sku) + '">',
                    '<div class="rg-rewards__mini-value">',
                    '<p class="rg-rewards__mini-off">' + escapePackHtml(amountText) + '</p>',
                    skuDesktop,
                    '<p class="rg-rewards__mini-min">' + escapePackHtml(minText) + '</p>',
                    '</div>',
                    '<div class="rg-rewards__mini-rule"></div>',
                    '<div class="rg-rewards__mini-body">',
                    photo
                        ? '<img class="rg-rewards__mini-photo" src="' + escapePackHtml(photo) + '" alt="" width="32" height="32">'
                        : '<span class="rg-rewards__mini-photo" aria-hidden="true"></span>',
                    '<div class="rg-rewards__mini-copy">',
                    '<p class="rg-rewards__mini-name">' + escapePackHtml(productName) + '</p>',
                    '<div class="rg-rewards__mini-tags">',
                    skuMobile,
                    statusHtml,
                    '</div>',
                    '</div>',
                    '<span class="rg-rewards__bundle-pill rg-rewards__mini-sku-desktop ' + status.tone + '">' + escapePackHtml(status.label) + '</span>',
                    '</div>',
                    '</article>'
                ].join('');
            }).join('');
        }

        function renderRewardsCouponsPending() {
            var text = rewardsConfig.couponsPendingText || 'Your coupons are still being issued. Please wait patiently.';
            var html = '<p class="rg-rewards__coupons-pending">' + escapePackHtml(text) + '</p>';
            var tickets = stateEl.querySelector('[data-rg-rewards-pack-tickets]');
            var cards = stateEl.querySelector('[data-rg-rewards-bundle-cards]');
            if (tickets) tickets.innerHTML = html;
            if (cards) cards.innerHTML = html;
        }

        function setRewardsOrdered(nextOrdered) {
            ordered = loggedIn && !!nextOrdered;
            stateEl.setAttribute('data-ordered', ordered ? 'true' : 'false');
            if (productsEl) productsEl.setAttribute('data-ordered', ordered ? 'true' : 'false');
            if (stateEl.rgRewardsState) stateEl.rgRewardsState.ordered = ordered;
            applyRewardsSaleState();
        }

        function setRewardsCouponsLoading(isLoading) {
            stateEl.setAttribute('data-coupons-loading', isLoading ? 'true' : 'false');
            var skeleton = stateEl.querySelector('[data-rg-rewards-coupons-skeleton]');
            if (skeleton) skeleton.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
            if (!isLoading) applyRewardsSaleState();
        }

        function renderPackTicketSkeleton(mount) {
            if (!mount) return;
            mount.innerHTML = [
                '<div class="rg-rewards__pack-ticket-skeleton" aria-hidden="true"></div>',
                '<div class="rg-rewards__pack-ticket-skeleton" aria-hidden="true"></div>',
                '<div class="rg-rewards__pack-ticket-skeleton" aria-hidden="true"></div>'
            ].join('');
        }

        function normalizeRewardsCouponItem(item) {
            if (!item) return null;
            var typeName = item.couponTypeName;
            if (!typeName && item.couponTypeId != null) {
                typeName = Number(item.couponTypeId) === 2 ? 'percentage_discount' : 'fixed_amount';
            }
            return {
                couponTemplateId: item.couponTemplateId,
                couponTypeName: typeName,
                couponAmount: item.couponAmount,
                minPurchase: item.minPurchase,
                couponExpires: item.couponExpires,
                createDate: item.createDate,
                cutoffType: item.cutoffType,
                couponRuleList: item.couponRuleList,
                couponCode: item.couponCode || '',
                couponStatus: item.couponStatus,
                couponTemplateProductDetailContentList: item.couponTemplateProductDetailContentList || item.couponProductDetailContentList || [],
                channelBusinessKey: item.channelBusinessKey
            };
        }

        function rewardsCouponCardState(item) {
            var status = String(item && item.couponStatus != null ? item.couponStatus : '').toLowerCase();
            if (status === '2' || status === 'used') return 'used';
            if (status === '3' || status === 'expired') return 'expired';
            if (status === '4' || status === 'abolished') return 'abolished';
            if (status === '0' || status === 'inactive' || status === 'not_active') return 'inactive';
            return 'usable';
        }

        function rewardsPackOffAmount(item) {
            var currency = getRewardsCurrencySymbol();
            var isPercent = item && item.couponTypeName === 'percentage_discount';
            return isPercent
                ? (Number(item.couponAmount || 0) + '%')
                : (currency + Number(item && item.couponAmount || 0).toFixed(0));
        }

        function rewardsMatchedProductPrice(item) {
            var matchedPrice = null;
            var matched = false;
            (item && item.couponTemplateProductDetailContentList || []).some(function (row) {
                var sku = String(row && row.sku || '').trim().toLowerCase();
                if (!sku) return false;
                var cards = root.querySelectorAll('.rg-rewards__product[data-sku]');
                return Array.prototype.some.call(cards, function (card) {
                    if (String(card.getAttribute('data-sku') || '').trim().toLowerCase() !== sku) return false;
                    matched = true;
                    var cents = Number(card.getAttribute('data-price-cents'));
                    if (isFinite(cents)) matchedPrice = cents / 100;
                    return true;
                });
            });
            return matched ? { price: matchedPrice } : null;
        }

        function applyRewardsCountCopy(count) {
            var vars = {
                count: count,
                price: rewardsConfig.depositPrice || '',
                coupons_total: rewardsConfig.couponsTotal || ''
            };
            function phrase(oneKey, otherKey) {
                var template = count === 1 ? rewardsUi[oneKey] : rewardsUi[otherKey];
                return rewardsFill(template, vars);
            }
            function write(key, custom, oneKey, otherKey) {
                var node = stateEl.querySelector('[data-rg-rewards-token-count="' + key + '"]');
                if (!node) return;
                if (!custom) {
                    node.textContent = count ? phrase(oneKey, otherKey) : '';
                    return;
                }
                var source = rewardsCountSources[key] || '';
                if (source.indexOf('{count}') === -1 && source.indexOf('{coupons_total}') === -1) return;
                node.textContent = rewardsFill(source, vars);
            }
            write('short', rewardsConfig.couponsLabelShortCustom, 'couponsLabelShortOne', 'couponsLabelShortOther');
            write('long', rewardsConfig.couponsLabelLongCustom, 'couponsLabelLongOne', 'couponsLabelLongOther');
            write('pack', rewardsConfig.packDescCustom, 'packDescGuestOne', 'packDescGuestOther');
            write('confirm', rewardsConfig.confirmCouponsCustom, 'confirmCouponsOne', 'confirmCouponsOther');
        }

        function applyRewardsCouponEquation(list) {
            var chips = [];
            var total = 0;
            var counted = 0;
            (list || []).forEach(function (item) {
                var match = rewardsMatchedProductPrice(item);
                if (!match) return;
                var isPercent = item.couponTypeName === 'percentage_discount';
                if (isPercent && match.price == null) return;
                var save = isPercent
                    ? match.price * Number(item.couponAmount || 0) / 100
                    : Number(item.couponAmount || 0);
                if (!isFinite(save)) return;
                chips.push(rewardsPackOffAmount(item));
                total += save;
                counted += 1;
            });
            if (!rewardsConfig.couponsChipsCustom) {
                var chipMount = stateEl.querySelector('.rg-rewards__eq-chips');
                if (chipMount) {
                    chipMount.innerHTML = chips.map(function (label) {
                        return '<span class="rg-rewards__eq-chip">' + escapePackHtml(label) + '</span>';
                    }).join('');
                }
            }
            if (!rewardsConfig.couponsTotalCustom) {
                var formatted = counted ? formatRewardsMoney(total) : '';
                rewardsConfig.couponsTotal = formatted;
                rewardsCouponTotalReady = true;
                var mobileTotal = stateEl.querySelector('.rg-rewards__eq-value--coupon');
                var worthTotal = stateEl.querySelector('.rg-rewards__eq-worth strong');
                if (mobileTotal) mobileTotal.textContent = formatted;
                if (worthTotal) worthTotal.textContent = formatted;
                renderRewardsCampaignCopy();
            }
            applyRewardsCountCopy(counted);
            renderRewardsPackNote();
        }

        function rewardsCouponSaving(price, item) {
            var amount = Number(item && item.couponAmount || 0);
            if (!isFinite(amount)) amount = 0;
            if (item && item.couponTypeName === 'percentage_discount') return price * amount / 100;
            return amount;
        }

        function applyProductAfterPrices(list) {
            var cards = root.querySelectorAll('.rg-rewards__product[data-sku][data-price-cents]');
            cards.forEach(function (card) {
                var box = card.querySelector('.rg-rewards__product-after');
                if (!box) return;
                var sku = String(card.getAttribute('data-sku') || '').trim().toLowerCase();
                var priceCents = Number(card.getAttribute('data-price-cents'));
                if (!sku || !isFinite(priceCents)) return;
                var price = priceCents / 100;
                var bound = false;
                var bestSave = -1;
                var finalPrice = null;
                (list || []).forEach(function (item) {
                    var matches = (item.couponTemplateProductDetailContentList || []).some(function (row) {
                        return String(row && row.sku || '').trim().toLowerCase() === sku;
                    });
                    if (!matches) return;
                    bound = true;
                    var threshold = item.minPurchase != null && item.minPurchase !== '' ? Number(item.minPurchase) : 0;
                    if (!isFinite(threshold)) threshold = 0;
                    if (price < threshold) return;
                    var save = rewardsCouponSaving(price, item);
                    if (save > bestSave) {
                        bestSave = save;
                        var next = item.couponTypeName === 'percentage_discount'
                            ? price * (1 - Number(item.couponAmount || 0) / 100)
                            : price - Number(item.couponAmount || 0);
                        finalPrice = Math.max(0, Math.round(next * 100) / 100);
                    }
                });
                if (!bound) {
                    box.classList.add('is-empty');
                    box.setAttribute('aria-hidden', 'true');
                    box.innerHTML = '';
                    return;
                }
                var shown = finalPrice == null ? price : finalPrice;
                box.classList.remove('is-empty');
                box.removeAttribute('aria-hidden');
                box.innerHTML = '<span>' + escapePackHtml(rewardsUi.priceAfterCoupon) + '</span><strong>' + escapePackHtml(formatRewardsMoney(shown)) + '</strong>';
            });
        }

        function applyProductCouponButtons(list) {
            var cards = root.querySelectorAll('.rg-rewards__product[data-sku]');
            var rank = { usable: 4, inactive: 3, used: 2, expired: 1, abolished: 0 };
            var bySku = {};

            cards.forEach(function (card) {
                var couponBtn = card.querySelector('[data-rg-rewards-product-coupon]');
                if (!couponBtn) return;
                couponBtn.hidden = true;
                couponBtn.disabled = true;
                couponBtn.removeAttribute('data-rg-rewards-copy');
                couponBtn.textContent = '';
            });

            if (!loggedIn || !ordered) return;

            (list || []).forEach(function (item) {
                var state = rewardsCouponCardState(item);
                (item.couponTemplateProductDetailContentList || []).forEach(function (row) {
                    var sku = String(row && row.sku || '').trim().toLowerCase();
                    if (!sku) return;
                    var prev = bySku[sku];
                    if (prev && rank[prev.state] >= rank[state]) return;
                    bySku[sku] = {
                        state: state,
                        code: item.couponCode || ''
                    };
                });
            });

            cards.forEach(function (card) {
                var sku = String(card.getAttribute('data-sku') || '').trim().toLowerCase();
                var match = bySku[sku];
                var couponBtn = card.querySelector('[data-rg-rewards-product-coupon]');
                if (!match || !couponBtn) return;
                var labels = {
                    usable: rewardsUi.copyCode,
                    inactive: rewardsUi.productAvailableLaunch,
                    used: rewardsUi.couponUsed,
                    expired: rewardsUi.couponExpired,
                    abolished: rewardsUi.unavailable
                };
                couponBtn.hidden = false;
                couponBtn.textContent = labels[match.state] || rewardsUi.copyCode;
                if (match.state === 'usable' && match.code) {
                    couponBtn.disabled = false;
                    couponBtn.setAttribute('data-rg-rewards-copy', match.code);
                    return;
                }
                couponBtn.disabled = true;
                couponBtn.removeAttribute('data-rg-rewards-copy');
            });
        }

        function loadRewardsCoupons() {
            var mount = stateEl.querySelector('[data-rg-rewards-pack-tickets]');
            var rewardsApiConfig = window.renogyConfig || {};
            var rewardsApiDomain = rewardsApiConfig.apiUrl || '';
            var rewardsStoreId = rewardsApiConfig.storeId || '1';
            var rewardsChannelKey = String(rewardsConfig.channelBusinessKey || 'CA0001').trim() || 'CA0001';
            var rewardsAccessToken = rewardsCookie(rewardsTokenKey('access'));
            var rewardsUseUserApi = loggedIn;

            renderPackTicketSkeleton(mount);
            setRewardsCouponsLoading(true);

            function finishRewardsCoupons(list, markOrdered, giftCards) {
                var couponList = list || [];
                setRewardsOrdered(!!markOrdered);
                if (markOrdered) renderRewardsGiftCard(giftCards || []);
                var packList = couponList.filter(function (item) {
                    var state = rewardsCouponCardState(item);
                    return state === 'usable' || state === 'inactive';
                });
                var equationList = packList.length ? packList : couponList;
                renderPackTickets(couponList);
                renderBundleCards(couponList);
                if (markOrdered && rewardsConfig.hasGiftOrderTag && !couponList.length) {
                    renderRewardsCouponsPending();
                }
                applyProductAfterPrices(couponList);
                applyRewardsCouponEquation(equationList);
                applyProductCouponButtons(ordered ? couponList : []);
                setRewardsCouponsLoading(false);
            }

            if (!rewardsApiDomain) {
                finishRewardsCoupons([], false);
                return;
            }

            function rewardsAcceptLanguage() {
                var shopifyLocale = ((window.Shopify && window.Shopify.locale) || 'en').toLowerCase();
                var shopifyCountry = ((window.Shopify && window.Shopify.country) || 'US').toUpperCase();
                var langKey = shopifyLocale.split('-')[0];
                var localeMap = {
                    en: 'en-US',
                    de: 'de-DE',
                    ja: 'ja-JP',
                    zh: 'zh-CN',
                    cs: 'cs-CZ',
                    da: 'da-DK',
                    es: 'es-ES',
                    fr: shopifyCountry === 'CA' ? 'fr-CA' : 'fr-FR',
                    it: 'it-IT',
                    nl: 'nl-NL',
                    pl: 'pl-PL',
                    ru: 'ru-RU',
                    tr: 'tr-TR',
                    uk: 'uk-UA',
                    pt: 'pt-PT',
                    ko: 'ko-KR',
                    sv: 'sv-SE'
                };
                return localeMap[langKey] || 'en-US';
            }

            function rewardsCouponList(resp) {
                if (!resp || resp.code !== '000000' || !resp.data) {
                    return { list: [] };
                }
                return {
                    list: (resp.data.contentList || []).map(normalizeRewardsCouponItem).filter(Boolean)
                };
            }

            function rewardsAuthGet(apiPath, requireAuth) {
                var headers = {
                    'Content-Type': 'application/json',
                    'Accept-Language': rewardsAcceptLanguage()
                };
                return rewardsWhenAuthReady().then(function () {
                    if (window.RenogyAuth && typeof window.RenogyAuth.request === 'function') {
                        return window.RenogyAuth.request(rewardsApiDomain + apiPath, {
                            method: 'GET',
                            headers: headers,
                            requireAuth: requireAuth === true
                        });
                    }
                    if (requireAuth) headers['X-Token'] = rewardsAccessToken || '';
                    return fetch(rewardsApiDomain + apiPath, {
                        method: 'GET',
                        headers: headers
                    }).then(function (response) {
                        if (!response.ok) throw new Error('HTTP ' + response.status);
                        return response.json();
                    });
                });
            }

            function rewardsMemGet(apiPath, requireAuth) {
                return rewardsAuthGet(apiPath, requireAuth).then(rewardsCouponList);
            }

            // Guest: public coupon templates. Logged-in order state is any returned user coupon.
            // MEM replaced channelBusinessKey with channelBusinessKeyList. Channel 100 is the storefront.
            function rewardsChannelQuery() {
                if (!rewardsChannelKey) return '';
                return '&channelBusinessKeyList=' + encodeURIComponent(rewardsChannelKey);
            }

            function fetchRewardsCouponTemplates() {
                var templatePath = '/mem-service/api/v1/bigcommerce/page_coupon_template'
                    + '?exchangeChannelList=100'
                    + '&appliesToEntity=products&isNeedCouponTemplateProduct=1'
                    + '&usePlatformId=' + encodeURIComponent(rewardsStoreId)
                    + '&pageSize=32&pageNum=1'
                    + rewardsChannelQuery();
                return rewardsMemGet(templatePath, false).then(function (result) {
                    return result.list || [];
                });
            }

            function fetchRewardsUserCoupons() {
                var userPath = '/mem-service/api/v1/bigcommerce/page_user_coupon'
                    + '?pageSize=32&pageNum=1'
                    + '&usePlatformId=' + encodeURIComponent(rewardsStoreId)
                    + '&isNeedCouponTemplateProduct=true'
                    + '&exchangeChannelList=100'
                    + rewardsChannelQuery();
                return rewardsMemGet(userPath, true).then(function (result) {
                    return { list: result.list || [] };
                }).catch(function () {
                    return { list: [] };
                });
            }

            function fetchRewardsUserGiftCards() {
                var giftPath = '/mem-service/api/v1/bigcommerce/page_user_gift_card'
                    + '?pageSize=32&pageNum=1'
                    + '&usePlatformId=' + encodeURIComponent(rewardsStoreId)
                    + '&exchangeChannelList=100'
                    + rewardsChannelQuery();
                return rewardsAuthGet(giftPath, true).then(function (resp) {
                    var data = resp && resp.data && resp.data.userGiftCardContentList ? resp.data : resp;
                    return (data && data.userGiftCardContentList) || [];
                }).catch(function () {
                    return [];
                });
            }

            function rewardsMaskGiftCode(code) {
                var value = String(code || '');
                if (!value) return '';
                return value.slice(0, 4) + '****' + value.slice(-3);
            }

            function rewardsGiftCardView(card) {
                var status = Number(card && card.giftCardStatus);
                var state = status === 1 ? 'usable'
                    : status === 2 ? 'used'
                    : status === 3 ? 'expired'
                    : status === 4 ? 'abolished'
                    : 'inactive';
                var labels = {
                    usable: rewardsUi.available,
                    used: rewardsUi.couponUsed,
                    expired: rewardsUi.couponExpired,
                    abolished: rewardsUi.unavailable,
                    inactive: rewardsUi.notActive
                };
                var amount = card.giftCardAmount != null ? card.giftCardAmount : card.giftCardBalance;
                var money = formatRewardsMoney(amount);
                var balanceMoney = formatRewardsBalance(amount);
                var expiry = rewardsExpiryStamp(card.giftCardExpires);
                var code = card.giftCardCode || '';
                return {
                    state: state,
                    label: labels[state] || rewardsUi.notActive,
                    tone: state === 'usable' ? 'is-usable' : (state === 'inactive' ? '' : 'is-muted'),
                    showStatus: state !== 'used',
                    code: code,
                    maskedCode: rewardsMaskGiftCode(code),
                    money: money,
                    valueText: rewardsFill(rewardsUi.bundleGiftValue || 'Balance: {price}', { price: balanceMoney }),
                    expiryText: expiry
                        ? rewardsFill(rewardsUi.validUntilLine, { prefix: rewardsUi.validUntil, date: expiry })
                        : ''
                };
            }

            function renderRewardsGiftCard(list) {
                var card = list && list[0];
                if (!card) return;
                var view = rewardsGiftCardView(card);
                var copyIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>';
                var statusHtml = view.showStatus
                    ? '<span class="rg-rewards__pack-status' + (view.tone ? ' ' + view.tone : '') + '">' + escapePackHtml(view.label) + '</span>'
                    : '';
                var codeHtml = statusHtml + (view.code
                    ? '<code class="rg-rewards__pack-code">' + escapePackHtml(view.maskedCode) + '</code>'
                        + '<button class="rg-rewards__pack-gift-copy" type="button" data-rg-rewards-copy="' + escapePackHtml(view.code) + '">'
                        + copyIcon
                        + '<span data-rg-rewards-copy-label>' + escapePackHtml(rewardsUi.copyLabel) + '</span></button>'
                    : '');
                var packGift = stateEl.querySelector('[data-rg-rewards-pack-gift]');
                if (packGift) {
                    var valueEl = packGift.querySelector('.rg-rewards__pack-gift-value');
                    var expiryEl = packGift.querySelector('.rg-rewards__pack-gift-expiry');
                    var actions = packGift.querySelector('.rg-rewards__pack-gift-actions');
                    if (valueEl) valueEl.textContent = view.money;
                    if (view.expiryText && expiryEl) expiryEl.textContent = view.expiryText;
                    if (actions) {
                        actions.innerHTML = codeHtml;
                    }
                }
                var bundleGift = stateEl.querySelector('[data-rg-rewards-bundle-gift]');
                if (bundleGift) {
                    var bundleValue = bundleGift.querySelector('.rg-rewards__bundle-gift-value');
                    var bundleSide = bundleGift.querySelector('.rg-rewards__bundle-gift-side');
                    if (bundleValue) bundleValue.textContent = view.valueText;
                    if (bundleSide) {
                        var bundleStatus = view.showStatus
                            ? '<span class="rg-rewards__bundle-pill ' + view.tone + '">' + escapePackHtml(view.label) + '</span>'
                            : '';
                        var bundleCode = view.code
                            ? '<code class="rg-rewards__bundle-code">' + escapePackHtml(view.maskedCode) + '</code>'
                                + '<button class="rg-rewards__bundle-copy" type="button" data-rg-rewards-copy="' + escapePackHtml(view.code) + '">'
                                + escapePackHtml(rewardsUi.copyLabel) + '</button>'
                            : '';
                        bundleSide.innerHTML = bundleStatus + bundleCode;
                    }
                }
            }

            var rewardsCouponRequest = rewardsUseUserApi
                ? fetchRewardsUserCoupons().then(function (userResult) {
                    var userList = (userResult && userResult.list) || [];
                    if (userList.length || rewardsConfig.hasGiftOrderTag) {
                        return fetchRewardsUserGiftCards().then(function (giftCards) {
                            return { list: userList, ordered: true, giftCards: giftCards };
                        });
                    }
                    return fetchRewardsCouponTemplates().then(function (templateList) {
                        return { list: templateList, ordered: false, giftCards: [] };
                    });
                })
                : fetchRewardsCouponTemplates().then(function (templateList) {
                    return { list: templateList, ordered: false, giftCards: [] };
                });

            rewardsCouponRequest
                .then(function (result) {
                    finishRewardsCoupons(result.list || [], result.ordered, result.giftCards || []);
                })
                .catch(function () {
                    finishRewardsCoupons([], false);
                });
        }

        function applyRewardsLogin(next) {
            loggedIn = !!next;
            stateEl.setAttribute('data-logged-in', loggedIn ? 'true' : 'false');
            if (stateEl.rgRewardsState) stateEl.rgRewardsState.loggedIn = loggedIn;
        }

        function settleRewardsLogin() {
            rewardsEnsureLogin(shopifyLoggedIn).then(function (next) {
                applyRewardsLogin(next);
                loadRewardsCoupons();
            });
        }

        settleRewardsLogin();

        var productScroller = root.querySelector('[data-rg-rewards-scroller]');
        if (productScroller) {
            var productRail = productScroller.querySelector('[data-rg-rewards-rail]');
            var productThumb = root.querySelector('[data-rg-rewards-thumb]');
            var productPrev = productScroller.querySelector('[data-rg-rewards-prev]');
            var productNext = productScroller.querySelector('[data-rg-rewards-next]');
            var productCount = productRail ? productRail.children.length : 0;

            function updateProductScroller() {
                if (!productRail) return;
                var max = Math.max(0, productRail.scrollWidth - productRail.clientWidth);
                var left = Math.max(0, Math.min(max, productRail.scrollLeft));
                if (productPrev) productPrev.disabled = left <= 1;
                if (productNext) productNext.disabled = max - left <= 1;
                if (productThumb && productCount) {
                    var fraction = Math.min(5, productCount) / productCount;
                    productThumb.style.width = (fraction * 100) + '%';
                    productThumb.style.marginLeft = (max ? (left / max) * (1 - fraction) * 100 : 0) + '%';
                }
                var card = productRail.firstElementChild;
                if (card) {
                    var cardBox = card.getBoundingClientRect();
                    var shellBox = productScroller.getBoundingClientRect();
                    productScroller.style.setProperty('--arrow-top', (cardBox.top - shellBox.top + cardBox.height / 2) + 'px');
                }
            }

            if (productRail) {
                productRail.addEventListener('scroll', updateProductScroller, { passive: true });
                window.addEventListener('resize', updateProductScroller);
                updateProductScroller();
            }
            if (productPrev) {
                productPrev.addEventListener('click', function () {
                    if (!productRail) return;
                    productRail.scrollBy({ left: -1 * (productRail.clientWidth + 12), behavior: 'smooth' });
                });
            }
            if (productNext) {
                productNext.addEventListener('click', function () {
                    if (!productRail) return;
                    productRail.scrollBy({ left: productRail.clientWidth + 12, behavior: 'smooth' });
                });
            }
        }

        root.addEventListener('click', function (event) {
            var productCoupon = event.target.closest('[data-rg-rewards-product-coupon]');
            if (productCoupon) {
                if (productCoupon.disabled || !productCoupon.getAttribute('data-rg-rewards-copy')) return;
                copyStaticCode(productCoupon, rewardsUi.codeCopied);
                return;
            }
            var couponButton = event.target.closest('[data-rg-rewards-get-coupons]');
            if (!couponButton || stateEl.getAttribute('data-ordered') === 'true') return;
            if (window.Swal) {
                window.Swal.fire({
                    toast: true,
                    position: 'center',
                    title: rewardsFill(rewardsUi.getCouponsToast, {
                        price: rewardsConfig.depositPrice || '',
                        coupons_total: rewardsConfig.couponsTotal || ''
                    }),
                    showConfirmButton: false,
                    timer: 3000,
                    customClass: {
                        popup: 'rg-rewards-tips-toast',
                        container: 'rg-rewards-tips-toast-container'
                    }
                });
            }
            stateEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        var tips = stateEl.querySelectorAll('[data-rg-rewards-tip]');
        var tipTimer = null;

        function desktopTips() {
            return window.matchMedia('(min-width: 1024px)').matches;
        }

        function closeTips(except) {
            tips.forEach(function (tip) {
                if (tip === except) return;
                tip.classList.remove('is-open');
                var btn = tip.querySelector('button');
                if (btn) btn.setAttribute('aria-expanded', 'false');
            });
        }

        function openTip(tip) {
            if (tipTimer) window.clearTimeout(tipTimer);
            closeTips(tip);
            tip.classList.add('is-open');
            var btn = tip.querySelector('button');
            if (btn) btn.setAttribute('aria-expanded', 'true');
        }

        tips.forEach(function (tip) {
            var btn = tip.querySelector('button');
            tip.addEventListener('mouseenter', function () {
                if (!desktopTips()) return;
                openTip(tip);
            });
            tip.addEventListener('mouseleave', function () {
                if (!desktopTips()) return;
                tipTimer = window.setTimeout(function () {
                    closeTips();
                }, 160);
            });
            if (!btn) return;
            btn.addEventListener('click', function () {
                if (desktopTips()) return;
                if (tip.classList.contains('is-open')) closeTips();
                else openTip(tip);
            });
        });

        document.addEventListener('click', function (event) {
            if (!event.target.closest || !event.target.closest('[data-rg-rewards-tip]')) closeTips();
        });
        var pack = stateEl.querySelector('[data-rg-rewards-pack]');
        var packOpenButtons = stateEl.querySelectorAll('[data-rg-rewards-pack-open]');
        var packReturn = null;

        function setPackOpen(open) {
            if (!pack) return;
            pack.hidden = !open;
            document.documentElement.style.overflow = dialogsOpen() ? 'hidden' : '';
            if (open) {
                packReturn = document.activeElement;
                var closeBtn = pack.querySelector('.rg-rewards__pack-close');
                if (closeBtn) closeBtn.focus();
                return;
            }
            if (packReturn && packReturn.focus) packReturn.focus();
        }

        packOpenButtons.forEach(function (packOpenBtn) {
            packOpenBtn.addEventListener('click', function () {
                setPackOpen(true);
            });
        });

        function markCopied(button, copiedText) {
            var label = button.querySelector('[data-rg-rewards-copy-label]');
            var target = label || button;
            var original = target.textContent;
            target.textContent = copiedText || rewardsUi.copied;
            window.setTimeout(function () {
                target.textContent = original;
            }, 2000);
        }

        function copyStaticCode(button, copiedText) {
            var code = button.getAttribute('data-rg-rewards-copy') || '';
            if (!code) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(code).then(function () {
                    markCopied(button, copiedText);
                }).catch(function () {
                    markCopied(button, copiedText);
                });
                return;
            }
            markCopied(button, copiedText);
        }

        var skuFocusTimer = null;

        function focusProductBySku(sku) {
            var normalized = String(sku || '').trim();
            if (!normalized) return false;

            var productsSection = root.querySelector('[data-rg-rewards-products]');
            var rail = root.querySelector('[data-rg-rewards-rail]');
            var target = findProductCardBySku(normalized);
            if (!target) return false;

            root.querySelectorAll('.rg-rewards__product.is-sku-focus').forEach(function (card) {
                card.classList.remove('is-sku-focus');
            });

            target.classList.add('is-sku-focus');
            if (skuFocusTimer) window.clearTimeout(skuFocusTimer);
            skuFocusTimer = window.setTimeout(function () {
                target.classList.remove('is-sku-focus');
            }, 5000);

            if (productsSection) {
                productsSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            if (rail) {
                window.requestAnimationFrame(function () {
                    var left = target.offsetLeft - (rail.clientWidth - target.offsetWidth) / 2;
                    rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
                });
            }
            return true;
        }

        var bundleCards = stateEl.querySelector('[data-rg-rewards-bundle-cards]');
        if (bundleCards) {
            bundleCards.addEventListener('click', function (event) {
                var skuBtn = event.target.closest('[data-rg-rewards-sku-focus]');
                if (!skuBtn) return;
                focusProductBySku(skuBtn.getAttribute('data-rg-rewards-sku-focus') || '');
            });
        }

        if (pack) {
            pack.addEventListener('click', function (event) {
                var skuBtn = event.target.closest('[data-rg-rewards-sku-focus]');
                if (skuBtn) {
                    var sku = skuBtn.getAttribute('data-rg-rewards-sku-focus') || '';
                    if (!findProductCardBySku(sku)) return;
                    setPackOpen(false);
                    window.setTimeout(function () {
                        focusProductBySku(sku);
                    }, 80);
                    return;
                }
                var copyBtn = event.target.closest('[data-rg-rewards-copy]');
                if (copyBtn) {
                    copyStaticCode(copyBtn);
                    return;
                }
                var inactiveBtn = event.target.closest('[data-rg-rewards-inactive]');
                if (inactiveBtn && window.Swal) {
                    var inactiveState = inactiveBtn.getAttribute('data-rg-rewards-inactive');
                    var inactiveTitle = inactiveState === 'used'
                        ? 'This coupon has already been redeemed and the deposit is no longer refundable'
                        : (inactiveState === 'expired' || inactiveState === 'abolished'
                            ? 'This coupon has expired'
                            : 'This coupon is not active yet');
                    window.Swal.fire({
                        toast: true,
                        position: 'center',
                        title: inactiveTitle,
                        showConfirmButton: false,
                        timer: 6000,
                        customClass: {
                            popup: 'rg-rewards-error-toast',
                            container: 'rg-rewards-error-toast-container'
                        }
                    });
                    return;
                }
                if (event.target.closest('[data-rg-rewards-pack-close]')) setPackOpen(false);
            });
        }
        stateEl.addEventListener('click', function (event) {
            var copyBtn = event.target.closest('[data-rg-rewards-copy]');
            if (!copyBtn || (pack && pack.contains(copyBtn))) return;
            copyStaticCode(copyBtn);
        });

        var confirmEl = stateEl.querySelector('[data-rg-rewards-confirm]');
        var confirmOpenBtn = stateEl.querySelector('[data-rg-rewards-confirm-open]');
        var depositAgree = stateEl.querySelector('[data-rg-rewards-deposit-agree]');
        var mailAgree = stateEl.querySelector('[data-rg-rewards-mail-agree]');
        var mailRow = stateEl.querySelector('[data-rg-rewards-mail-row]');
        var checkoutBtn = stateEl.querySelector('[data-rg-rewards-checkout]');
        var checkoutForm = stateEl.querySelector('[data-rg-rewards-checkout-form]');
        var subscribedKey = 'rg-rewards-subscribed-' + boot.sectionId;

        function sessionAlreadySubscribed() {
            try {
                return window.sessionStorage.getItem(subscribedKey) === '1';
            } catch (error) {
                return false;
            }
        }

        function syncCheckout() {
            if (!checkoutBtn) return;
            var depositOk = !!(depositAgree && depositAgree.checked);
            var mailNeeded = mailRow && !mailRow.hidden;
            var mailOk = !mailNeeded || !!(mailAgree && mailAgree.checked);
            checkoutBtn.disabled = !(depositOk && mailOk && checkoutForm);
        }

        function setConfirmOpen(open) {
            if (!confirmEl) return;
            if (open && mailRow) mailRow.hidden = loggedIn || sessionAlreadySubscribed();
            confirmEl.hidden = !open;
            document.documentElement.style.overflow = dialogsOpen() ? 'hidden' : '';
            syncCheckout();
        }

        if (confirmOpenBtn) {
            confirmOpenBtn.addEventListener('click', function () {
                setConfirmOpen(true);
            });
        }
        if (depositAgree) depositAgree.addEventListener('change', syncCheckout);
        if (mailAgree) mailAgree.addEventListener('change', syncCheckout);
        if (confirmEl) {
            confirmEl.addEventListener('click', function (event) {
                if (event.target.closest('[data-rg-rewards-confirm-close]')) setConfirmOpen(false);
            });
        }
        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', function () {
                if (!checkoutForm || checkoutBtn.disabled) return;
                var shouldSubscribe = mailRow && !mailRow.hidden && mailAgree && mailAgree.checked;
                var email = checkoutForm.getAttribute('data-email') || '';
                function goCheckout() {
                    var url = checkoutForm.getAttribute('data-checkout-url') || checkoutForm.getAttribute('action');
                    if (url) window.location.assign(url);
                }
                if (!shouldSubscribe || !email) {
                    goCheckout();
                    return;
                }
                checkoutBtn.disabled = true;
                var isProduction = window.location.hostname.indexOf('renogy.com') > -1;
                var apiUrl = isProduction ? 'https://shopify-api.renogy.com' : 'https://d-shopify-api.renogy.cn';
                var currentDomain = isProduction ? window.location.hostname : 'shopify-uk.renogy.cn';
                var host = window.location.hostname;
                var sites = {
                    'uk.renogy.com': 'UK',
                    'www.renogy.com': 'US',
                    'ca.renogy.com': 'CA',
                    'au.renogy.com': 'AU',
                    'de.renogy.com': 'DE',
                    'eu.renogy.com': 'EU',
                    'jp.renogy.com': 'JP',
                    'nl.renogy.com': 'NL',
                    'fr.renogy.com': 'FR',
                    'it.renogy.com': 'IT',
                    'es.renogy.com': 'ES',
                    'za.renogy.com': 'ZA'
                };
                var query = 'Email=' + encodeURIComponent(email) + '&storeName=' + encodeURIComponent(sites[host] || 'RenogyTest');
                fetch(apiUrl + '/api/shopify-client/subscript?' + query, {
                    method: 'GET',
                    headers: { 'X-Origin-Domain': currentDomain }
                }).finally(function () {
                    try {
                        window.sessionStorage.setItem(subscribedKey, '1');
                    } catch (error) {}
                    goCheckout();
                });
            });
        }

        var termsEl = stateEl.querySelector('.rg-rewards__confirm[data-rg-rewards-terms]');
        var shareEl = stateEl.querySelector('[data-rg-rewards-share]');
        var shareCopy = stateEl.querySelector('[data-rg-rewards-share-copy]');

        function dialogsOpen() {
            return (pack && !pack.hidden) || (confirmEl && !confirmEl.hidden) || (termsEl && !termsEl.hidden) || (shareEl && !shareEl.hidden);
        }

        function setTermsOpen(open) {
            if (!termsEl) return;
            termsEl.hidden = !open;
            document.documentElement.style.overflow = dialogsOpen() ? 'hidden' : '';
        }

        function setShareOpen(open) {
            if (!shareEl) return;
            shareEl.hidden = !open;
            document.documentElement.style.overflow = dialogsOpen() ? 'hidden' : '';
        }

        stateEl.querySelectorAll('[data-rg-rewards-terms-open]').forEach(function (button) {
            button.addEventListener('click', function () {
                setTermsOpen(true);
            });
        });
        stateEl.querySelectorAll('[data-rg-rewards-share-open]').forEach(function (button) {
            button.addEventListener('click', function () {
                setShareOpen(true);
            });
        });
        if (termsEl) {
            termsEl.addEventListener('click', function (event) {
                if (event.target.closest('[data-rg-rewards-terms-close]')) setTermsOpen(false);
            });
        }
        if (shareEl) {
            shareEl.addEventListener('click', function (event) {
                if (event.target.closest('[data-rg-rewards-share-close]')) setShareOpen(false);
            });
        }
        if (shareCopy) {
            shareCopy.addEventListener('click', function () {
                var urlEl = stateEl.querySelector('[data-rg-rewards-share-url]');
                var url = urlEl ? urlEl.textContent.trim() : '';
                if (url && navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(url).then(function () {
                        markCopied(shareCopy);
                    }).catch(function () {
                        markCopied(shareCopy);
                    });
                    return;
                }
                markCopied(shareCopy);
            });
        }

        document.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') return;
            closeTips();
            if (pack && !pack.hidden) setPackOpen(false);
            if (confirmEl && !confirmEl.hidden) setConfirmOpen(false);
            if (termsEl && !termsEl.hidden) setTermsOpen(false);
            if (shareEl && !shareEl.hidden) setShareOpen(false);
        });

        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        function badgeDate(value) {
            var iso = String(value).match(/(\d{4})-(\d{2})-(\d{2})/);
            if (iso) {
                return (months[Number(iso[2]) - 1] + ' ' + Number(iso[3])).toUpperCase();
            }

            var parsed = Date.parse(value);
            if (isNaN(parsed)) return '';

            var offset = String(value).match(/([+-])(\d{2}):?(\d{2})\s*$/);
            var date = new Date(parsed);
            if (offset) {
                var sign = offset[1] === '-' ? -1 : 1;
                var shift = sign * (Number(offset[2]) * 60 + Number(offset[3]));
                var zoned = new Date(date.getTime() + shift * 60000);
                return (months[zoned.getUTCMonth()] + ' ' + zoned.getUTCDate()).toUpperCase();
            }

            return (months[date.getUTCMonth()] + ' ' + date.getUTCDate()).toUpperCase();
        }

        function rewardsLocalEndLabel() {
            if (isNaN(end)) return '';
            var locale = (window.Shopify && window.Shopify.locale) || navigator.language || 'en';
            try {
                return new Intl.DateTimeFormat(locale, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                }).format(new Date(end));
            } catch (error) {
                return new Date(end).toLocaleString();
            }
        }

        function renderRewardsPackNote() {
            var note = stateEl.querySelector('[data-rg-rewards-pack-note]');
            if (!note) return;
            if (!note.hasAttribute('data-rg-rewards-note-source')) {
                note.setAttribute('data-rg-rewards-note-source', note.textContent || '');
            }
            var source = rewardsConfig.packNoteCustom
                ? (note.getAttribute('data-rg-rewards-note-source') || '')
                : (rewardsUi.packNote || '');
            if (rewardsConfig.packNoteCustom && source.indexOf('{expiry}') === -1) return;
            var localEnd = rewardsLocalEndLabel();
            if (!localEnd) return;
            var vars = {
                expiry: localEnd,
                price: rewardsConfig.depositPrice || ''
            };
            if (rewardsCouponTotalReady) vars.coupons_total = rewardsConfig.couponsTotal || '';
            note.textContent = rewardsFill(source, vars);
        }

        var startLabel = badgeDate(startRaw);
        var endLabel = badgeDate(endRaw);
        var endedPretty = endLabel
            ? endLabel.split(' ').map(function (part, index) {
                if (index !== 0) return part;
                return part.charAt(0) + part.slice(1).toLowerCase();
            }).join(' ')
            : '';
        var endedEl = stateEl.querySelector('[data-rg-rewards-ended]');
        if (endedEl) {
            endedEl.textContent = rewardsFill(rewardsUi.saleEnded, { date: endedPretty });
        }

        function paintCountdown() {
            var cells = stateEl.querySelectorAll('[data-rg-rewards-count]');
            if (!cells.length || stage === 'ended') return;
            var target = stage === 'upcoming' ? start : end;
            var diff = isNaN(target) ? 0 : Math.max(0, target - Date.now());
            var total = Math.floor(diff / 1000);
            var parts = {
                d: Math.floor(total / 86400),
                h: Math.floor(total / 3600) % 24,
                m: Math.floor(total / 60) % 60,
                s: total % 60
            };
            cells.forEach(function (cell) {
                var key = cell.getAttribute('data-rg-rewards-count');
                var value = parts[key] || 0;
                cell.textContent = String(value).padStart(2, '0');
            });
        }

        paintCountdown();
        if (stage !== 'ended') window.setInterval(paintCountdown, 1000);

        function formatRewardsCount(value) {
            var amount = Math.max(0, Math.floor(Number(value) || 0));
            return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        function applyRewardsStockTone() {
            if (stage !== 'live') return;
            var spotsLeft = Number(rewardsConfig.spotsLeft);
            var spotsTotal = Number(rewardsConfig.spotsTotal);
            if (isNaN(spotsLeft) || isNaN(spotsTotal) || spotsTotal <= 0) return;
            var stockEl = stateEl.querySelector('.rg-rewards__meta-stock-text--live');
            var bar = stateEl.querySelector('.rg-rewards__meta-bar');
            if (!stockEl) return;
            var ratio = spotsLeft / spotsTotal;
            stockEl.classList.remove('is-warning', 'is-critical');
            if (bar) bar.classList.remove('is-warning', 'is-critical');
            if (spotsLeft <= 0) {
                stockEl.textContent = rewardsFill(rewardsUi.stockSoldOut, {
                    spots: '0',
                    total: formatRewardsCount(spotsTotal)
                });
                stockEl.classList.add('is-critical');
                if (bar) bar.classList.add('is-critical');
                return;
            }
            if (ratio <= 0.05) {
                stockEl.textContent = rewardsFill(rewardsUi.stockCritical, {
                    spots: formatRewardsCount(spotsLeft),
                    total: formatRewardsCount(spotsTotal)
                });
                stockEl.classList.add('is-critical');
                if (bar) bar.classList.add('is-critical');
                return;
            }
            if (ratio <= 0.2) {
                stockEl.textContent = rewardsFill(rewardsUi.stockWarning, {
                    spots: formatRewardsCount(spotsLeft),
                    total: formatRewardsCount(spotsTotal)
                });
                stockEl.classList.add('is-warning');
                if (bar) bar.classList.add('is-warning');
            }
        }

        function applyRewardsSaleState() {
            var spotsLeft = Number(rewardsConfig.spotsLeft);
            var couponsReady = stateEl.getAttribute('data-coupons-loading') !== 'true';
            var soldOut = couponsReady && stage === 'live' && !ordered && spotsLeft <= 0;
            stateEl.setAttribute('data-sold-out', soldOut ? 'true' : 'false');

            stateEl.querySelectorAll('.rg-rewards__buy-main').forEach(function (btn) {
                if (btn.classList.contains('rg-rewards__buy-secured')) return;
                if (!btn.getAttribute('data-rg-rewards-buy-label')) {
                    btn.setAttribute('data-rg-rewards-buy-label', btn.textContent || '');
                }
                if (soldOut) {
                    btn.disabled = true;
                    btn.textContent = rewardsUi.soldOut;
                    return;
                }
                btn.disabled = false;
                btn.textContent = btn.getAttribute('data-rg-rewards-buy-label');
            });
        }

        applyRewardsStockTone();
        applyRewardsSaleState();

        var titleEl = stateEl.querySelector('[data-rg-rewards-title]');
        var titles = boot.titles || {};
        var highlights = boot.highlights || {};

        function escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        function highlightLine(line, highlight) {
            var needle = String(highlight || '');
            if (!needle || line.indexOf(needle) === -1) return escapeHtml(line);
            return line.split(needle).map(escapeHtml).join('<span class="rg-rewards__title-em">' + escapeHtml(needle) + '</span>');
        }

        function fillCampaignTokens(text) {
            var tokenDate = stage === 'upcoming' ? startLabel : endLabel;
            return rewardsFill(text, {
                price: rewardsConfig.depositPrice || '',
                coupons_total: rewardsConfig.couponsTotal || '',
                expiry: rewardsConfig.rewardsExpiry || '',
                date: tokenDate || ''
            });
        }

        var descriptions = boot.descriptions || {};
        var descriptionEl = stateEl.querySelector('[data-rg-rewards-description]');

        function renderRewardsCampaignCopy() {
            if (titleEl) {
                var titleKey = stage === 'ended' ? 'ended' : 'active';
                var filledTitle = fillCampaignTokens(titles[titleKey] || '');
                var filledHighlight = fillCampaignTokens(highlights[titleKey] || '');
                var titleHtml = String(filledTitle).split(/\r?\n/).filter(function (line) {
                    return line.length;
                }).map(function (line) {
                    return '<span class="rg-rewards__title-line">' + highlightLine(line, filledHighlight) + '</span>';
                }).join('');
                titleEl.innerHTML = titleHtml;
                titleEl.setAttribute('data-stage', stage);
            }
            if (descriptionEl) {
                descriptionEl.textContent = fillCampaignTokens(descriptions[stage] || '');
                descriptionEl.setAttribute('data-stage', stage);
            }
            if (!rewardsCouponTotalReady) return;
            stateEl.querySelectorAll('[data-rg-rewards-token-coupons]').forEach(function (node) {
                var text = node.textContent || '';
                if (text.indexOf('{coupons_total}') === -1) return;
                node.textContent = text.replace(/\{coupons_total\}/g, rewardsConfig.couponsTotal || '');
            });
        }

        stateEl.querySelectorAll('[data-rg-rewards-token-count]').forEach(function (node) {
            rewardsCountSources[node.getAttribute('data-rg-rewards-token-count')] = node.textContent || '';
        });

        renderRewardsPackNote();
        renderRewardsCampaignCopy();

        var subscribeForm = stateEl.querySelector('[data-rg-rewards-subscribe]');
        if (subscribeForm) {
            var emailInput = subscribeForm.querySelector('input[name="sub-email"]');
            var submitBtn = subscribeForm.querySelector('.rg-rewards__subscribe-button');
            var termsCheck = subscribeForm.querySelector('[data-rg-rewards-terms]');
            var formField = subscribeForm.querySelector('[data-form-field]');
            var terms = subscribeForm.querySelector('.rg-rewards__subscribe-terms');
            var successMessage = subscribeForm.querySelector('.rg-rewards__subscribe-success');
            var successText = subscribeForm.querySelector('[data-rg-rewards-subscribed-text]');
            var tagUpcoming = boot.tagUpcoming || '';
            var tagEnded = boot.tagEnded || '';
            var tagName = stage === 'ended' ? tagEnded : tagUpcoming;
            var sessionKey = 'rg-rewards-subscribed-' + boot.sectionId;
            var errorText = boot.subscribeError || 'Subscription failed. Please try again.';
            var toastErrorIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true"><rect x="5" y="5" width="18" height="18" rx="9" stroke="#E04700" stroke-width="2"/><circle cx="14" cy="10.1992" r="1" fill="#E04700"/><rect x="13" y="12" width="2" height="6.8" rx="1" fill="#E04700"/></svg>';

            function showErrorToast(message) {
                if (!window.Swal) return;
                window.Swal.fire({
                    toast: true,
                    position: 'center',
                    title: message || errorText,
                    iconHtml: toastErrorIcon,
                    showConfirmButton: false,
                    timer: 6000,
                    customClass: {
                        popup: 'rg-rewards-error-toast',
                        container: 'rg-rewards-error-toast-container'
                    }
                });
            }

            function rewardsSite() {
                var host = window.location.hostname;
                var sites = {
                    'uk.renogy.com': 'UK',
                    'www.renogy.com': 'US',
                    'ca.renogy.com': 'CA',
                    'au.renogy.com': 'AU',
                    'de.renogy.com': 'DE',
                    'eu.renogy.com': 'EU',
                    'jp.renogy.com': 'JP',
                    'nl.renogy.com': 'NL',
                    'fr.renogy.com': 'FR',
                    'it.renogy.com': 'IT',
                    'es.renogy.com': 'ES',
                    'za.renogy.com': 'ZA'
                };
                return sites[host] || 'RenogyTest';
            }

            function setSuccessVisible(visible) {
                if (!successMessage) return;
                successMessage.style.display = visible ? 'flex' : 'none';
            }

            function subscribedCopy() {
                if (stage === 'upcoming') return rewardsUi.subscribeSuccessUpcoming;
                return rewardsUi.subscribeSuccessEnded;
            }

            function rememberSubscribed() {
                try {
                    window.sessionStorage.setItem(sessionKey, '1');
                } catch (error) {}
            }

            function sessionSubscribed() {
                try {
                    return window.sessionStorage.getItem(sessionKey) === '1';
                } catch (error) {
                    return false;
                }
            }

            function showSubscribed() {
                if (successText) successText.textContent = subscribedCopy();
                if (formField) formField.style.display = 'none';
                if (terms) terms.style.display = 'none';
                setSuccessVisible(true);
                if (submitBtn) {
                    submitBtn.classList.remove('is-loading');
                    submitBtn.removeAttribute('disabled');
                }
                if (emailInput) emailInput.removeAttribute('disabled');
            }

            if (stage === 'upcoming' && emailInput) {
                emailInput.placeholder = rewardsUi.subscribePlaceholderUpcoming;
            }
            if (sessionSubscribed()) showSubscribed();

            subscribeForm.addEventListener('submit', function (event) {
                event.preventDefault();
                if (!emailInput || !submitBtn || !termsCheck || !formField || !successMessage) return;
                setSuccessVisible(false);
                if (!termsCheck.checked) {
                    termsCheck.classList.add('is-shake');
                    window.setTimeout(function () {
                        termsCheck.classList.remove('is-shake');
                    }, 500);
                    return;
                }

                var isProduction = window.location.hostname.indexOf('renogy.com') > -1;
                var apiUrl = isProduction ? 'https://shopify-api.renogy.com' : 'https://d-shopify-api.renogy.cn';
                var currentDomain = isProduction ? window.location.hostname : 'shopify-uk.renogy.cn';
                var query = 'Email=' + encodeURIComponent(emailInput.value) + '&storeName=' + encodeURIComponent(rewardsSite());
                if (tagName && String(tagName).trim() !== '') {
                    query += '&tagName=' + encodeURIComponent(String(tagName).trim());
                }

                submitBtn.setAttribute('disabled', 'disabled');
                submitBtn.classList.add('is-loading');
                emailInput.setAttribute('disabled', 'disabled');

                fetch(apiUrl + '/api/shopify-client/subscript?' + query, {
                    method: 'GET',
                    headers: { 'X-Origin-Domain': currentDomain }
                }).then(function (response) {
                    return response.json();
                }).then(function (result) {
                    if (result && result.code === 200) {
                        emailInput.value = '';
                        termsCheck.checked = false;
                        rememberSubscribed();
                        showSubscribed();
                        return;
                    }
                    submitBtn.classList.remove('is-loading');
                    submitBtn.removeAttribute('disabled');
                    emailInput.removeAttribute('disabled');
                    showErrorToast(errorText);
                }).catch(function () {
                    submitBtn.classList.remove('is-loading');
                    submitBtn.removeAttribute('disabled');
                    emailInput.removeAttribute('disabled');
                    showErrorToast(errorText);
                });
            });
        }
    }

    function bootRgRewards() {
        var queue = window.RgRewardsBoots || [];
        window.RgRewardsBoots = [];
        queue.forEach(function (boot) {
            initRgRewards(boot);
        });
    }

    window.RgRewardsStart = bootRgRewards;
    if (!window.RgRewardsBound) {
        window.RgRewardsBound = true;
        document.addEventListener('shopify:section:load', bootRgRewards);
    }
    bootRgRewards();
})();
